import PermIdentity from '@material-ui/icons/PermIdentity';
import {SuppliersList} from "./SuppliersList";
import {SuppliersCreate} from "./SuppliersCreate";
import {SuppliersEdit} from "./SuppliersEdit";
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: SuppliersList,
    create: SuppliersCreate,
    edit: SuppliersEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;